import { Component, OnInit } from '@angular/core';
import { AllPageService } from "src/app/shared/services/all-page.service";
declare var jQuery: any;
declare var $: any; 

@Component({
  selector: 'app-ground',
  templateUrl: './ground.component.html',
  styleUrls: ['./ground.component.scss']
})
export class GroundComponent implements OnInit {

  groundList: any = "";

  constructor(private allpagesService: AllPageService,) { }

  ngOnInit() {
    this.allpagesService.getHistoryGround().then((data) => {
			this.groundList = data; 
			console.warn(this.groundList);
      setTimeout(() => {
        jQuery(".ground-hero-developments-top ul li").click(function () {
          if (jQuery(this).hasClass('active')) {
            // do nothing
          } else {
            jQuery(".ground-hero-developments-top ul li").removeClass('active');
            jQuery(this).addClass('active');
          }
          return false;
        });

      }, 1000);

		});
    
  }

}
